<template>
    <div class="page--premios d-flex align-items-center flex-column justify-content-between">
        <div class="bandeirolabg">
            <img class="lat-pulse" src="absoluto/assets/images/premios/bandeirola-premio.webp" alt="">
        </div>

        <h1 class="text-centr mt-5 mt-md-0">Prêmios</h1>

        <b-container>
            <div id="parent-to-motion--premios">
                <div class="opacity0">
                    <picture>
                        <source media="(min-width:280px)" srcset="absoluto/assets/images/premios/premios.webp">
                        <img
                            class="pulse"
                            src="absoluto/assets/images/premios/premios.webp"
                            :alt='Premios'
                            :title='Premios'
                        />
                    </picture>
                </div>
            </div>
        </b-container>

    </div>
</template>

<script>
export default {
    name: "Premios",
    components: {
    },
    data() {
        return {
            Premios: 'Todos os dias R$ 1.000 em certificado de ouro'
        }
    },
    methods: {
    },
    mounted() {
    }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/global";
@import "../assets/scss/onepage";

.page--premios {
    padding-top: 2rem;
    img {
        margin: 0 auto;
    }

}

.bandeirolabg {
    width: 100%;
    max-width: 2000px;
    display: flex;
    justify-content: center;
    position: absolute;
    top: -60px;

    img {
        max-width: 2000px;
    }
    // background-image: url(absoluto/assets/images/premios/bandeirola-premio.webp);
    // background-repeat: repeat-x;
    // animation: moveCenterX 3s infinite linear;
    // height: 230px;
    // position: absolute;
    // top: -63px;
    // left: -300px;
}

@media (max-width: $mobile), (orientation:portrait) {
    .bandeirolabg {
        top: -20px;
        img {
            max-width: 2000px !important;
        }
    }
    .page--premios {
        //padding-bottom: $paddingMobileInternas;
        display: flex !important;
        justify-content: center;
        align-items: center;

        img {
            max-width: 85%;
        }

        .m-top {
            margin-top: 70px;
        }
    }
}
</style>
